import {
  GET_TEAM_CONTRACTS,
  GET_TEAM_CONTRACTS_ERROR,
  GET_TEAM_CONTRACTS_SUCCESS,
} from "../actions/teamActions";

interface TeamState {
  teamContracts: Record<string, unknown>;
  fetchingTeamContracts: boolean;
  fetchTeamContractsComplete: boolean;
  fetchTeamContractsError: unknown;
}

interface TeamAction {
  type: string;
  payload: {
    data?: unknown;
  };
}

export function teamReducer(
  state: TeamState = {
    teamContracts: {},
    fetchingTeamContracts: false,
    fetchTeamContractsComplete: false,
    fetchTeamContractsError: undefined,
  },
  action: TeamAction
) {
  switch (action.type) {
    case GET_TEAM_CONTRACTS:
      return Object.assign({}, state, {
        fetchingTeamContracts: true,
        fetchTeamContractsComplete: false,
      });
    case GET_TEAM_CONTRACTS_SUCCESS:
      return Object.assign({}, state, {
        fetchingTeamContracts: false,
        fetchTeamContractsComplete: true,
        teamContracts: action.payload.data,
      });
    case GET_TEAM_CONTRACTS_ERROR:
      return Object.assign({}, state, {
        fetchingTeamContracts: false,
        fetchTeamContractsComplete: true,
        fetchTeamContractsError: action.payload.data,
      });
    default:
      return state;
  }
}
